module.exports = __webpack_public_path__ + "f6b6923c737960be51e947439bae88dc.png";